// Maps national team names to ISO 3166-1 alpha-2 codes.
// Home nations of the UK use country-flag-icons subdivision codes
// (GB-ENG, GB-SCT, GB-WLS, GB-NIR) so they render distinct flags.
// Kosovo uses XK (FIFA / country-flag-icons convention, not standard ISO).
const TEAM_NAME_TO_COUNTRY_CODE = {
    'afghanistan': 'AF',
    'albania': 'AL',
    'algeria': 'DZ',
    'american samoa': 'AS',
    'andorra': 'AD',
    'angola': 'AO',
    'anguilla': 'AI',
    'antigua and barbuda': 'AG',
    'argentina': 'AR',
    'armenia': 'AM',
    'aruba': 'AW',
    'australia': 'AU',
    'austria': 'AT',
    'azerbaijan': 'AZ',
    'bahamas': 'BS',
    'bahrain': 'BH',
    'bangladesh': 'BD',
    'barbados': 'BB',
    'belarus': 'BY',
    'belgium': 'BE',
    'belize': 'BZ',
    'benin': 'BJ',
    'bermuda': 'BM',
    'bhutan': 'BT',
    'bolivia': 'BO',
    'bosnia and herzegovina': 'BA',
    'bosnia & herzegovina': 'BA',
    'botswana': 'BW',
    'brazil': 'BR',
    'british virgin islands': 'VG',
    'brunei': 'BN',
    'brunei darussalam': 'BN',
    'bulgaria': 'BG',
    'burkina faso': 'BF',
    'burundi': 'BI',
    'cabo verde': 'CV',
    'cape verde': 'CV',
    'cambodia': 'KH',
    'cameroon': 'CM',
    'canada': 'CA',
    'cayman islands': 'KY',
    'central african republic': 'CF',
    'chad': 'TD',
    'chile': 'CL',
    'china': 'CN',
    'china pr': 'CN',
    'chinese taipei': 'TW',
    'taiwan': 'TW',
    'colombia': 'CO',
    'comoros': 'KM',
    'congo': 'CG',
    'congo dr': 'CD',
    'dr congo': 'CD',
    'democratic republic of the congo': 'CD',
    'cook islands': 'CK',
    'costa rica': 'CR',
    "côte d'ivoire": 'CI',
    "cote d'ivoire": 'CI',
    'ivory coast': 'CI',
    'croatia': 'HR',
    'cuba': 'CU',
    'curaçao': 'CW',
    'curacao': 'CW',
    'cyprus': 'CY',
    'czechia': 'CZ',
    'czech republic': 'CZ',
    'denmark': 'DK',
    'djibouti': 'DJ',
    'dominica': 'DM',
    'dominican republic': 'DO',
    'east timor': 'TL',
    'timor-leste': 'TL',
    'ecuador': 'EC',
    'egypt': 'EG',
    'el salvador': 'SV',
    'england': 'GB-ENG',
    'equatorial guinea': 'GQ',
    'eritrea': 'ER',
    'estonia': 'EE',
    'eswatini': 'SZ',
    'swaziland': 'SZ',
    'ethiopia': 'ET',
    'faroe islands': 'FO',
    'fiji': 'FJ',
    'finland': 'FI',
    'france': 'FR',
    'gabon': 'GA',
    'gambia': 'GM',
    'georgia': 'GE',
    'germany': 'DE',
    'ghana': 'GH',
    'gibraltar': 'GI',
    'greece': 'GR',
    'grenada': 'GD',
    'guam': 'GU',
    'guatemala': 'GT',
    'guinea': 'GN',
    'guinea-bissau': 'GW',
    'guyana': 'GY',
    'haiti': 'HT',
    'honduras': 'HN',
    'hong kong': 'HK',
    'hungary': 'HU',
    'iceland': 'IS',
    'india': 'IN',
    'indonesia': 'ID',
    'iran': 'IR',
    'iraq': 'IQ',
    'ireland': 'IE',
    'republic of ireland': 'IE',
    'israel': 'IL',
    'italy': 'IT',
    'jamaica': 'JM',
    'japan': 'JP',
    'jordan': 'JO',
    'kazakhstan': 'KZ',
    'kenya': 'KE',
    'korea dpr': 'KP',
    'north korea': 'KP',
    'korea republic': 'KR',
    'south korea': 'KR',
    'kosovo': 'XK',
    'kuwait': 'KW',
    'kyrgyzstan': 'KG',
    'kyrgyz republic': 'KG',
    'laos': 'LA',
    'latvia': 'LV',
    'lebanon': 'LB',
    'lesotho': 'LS',
    'liberia': 'LR',
    'libya': 'LY',
    'liechtenstein': 'LI',
    'lithuania': 'LT',
    'luxembourg': 'LU',
    'macau': 'MO',
    'macao': 'MO',
    'madagascar': 'MG',
    'malawi': 'MW',
    'malaysia': 'MY',
    'maldives': 'MV',
    'mali': 'ML',
    'malta': 'MT',
    'mauritania': 'MR',
    'mauritius': 'MU',
    'mexico': 'MX',
    'moldova': 'MD',
    'mongolia': 'MN',
    'montenegro': 'ME',
    'montserrat': 'MS',
    'morocco': 'MA',
    'mozambique': 'MZ',
    'myanmar': 'MM',
    'burma': 'MM',
    'namibia': 'NA',
    'nepal': 'NP',
    'netherlands': 'NL',
    'new caledonia': 'NC',
    'new zealand': 'NZ',
    'nicaragua': 'NI',
    'niger': 'NE',
    'nigeria': 'NG',
    'north macedonia': 'MK',
    'macedonia': 'MK',
    'northern ireland': 'GB-NIR',
    'norway': 'NO',
    'oman': 'OM',
    'pakistan': 'PK',
    'palestine': 'PS',
    'panama': 'PA',
    'papua new guinea': 'PG',
    'paraguay': 'PY',
    'peru': 'PE',
    'philippines': 'PH',
    'poland': 'PL',
    'portugal': 'PT',
    'puerto rico': 'PR',
    'qatar': 'QA',
    'romania': 'RO',
    'russia': 'RU',
    'rwanda': 'RW',
    'saint kitts and nevis': 'KN',
    'saint lucia': 'LC',
    'saint vincent and the grenadines': 'VC',
    'samoa': 'WS',
    'san marino': 'SM',
    'são tomé and príncipe': 'ST',
    'sao tome and principe': 'ST',
    'saudi arabia': 'SA',
    'scotland': 'GB-SCT',
    'senegal': 'SN',
    'serbia': 'RS',
    'seychelles': 'SC',
    'sierra leone': 'SL',
    'singapore': 'SG',
    'slovakia': 'SK',
    'slovenia': 'SI',
    'solomon islands': 'SB',
    'somalia': 'SO',
    'south africa': 'ZA',
    'south sudan': 'SS',
    'spain': 'ES',
    'sri lanka': 'LK',
    'sudan': 'SD',
    'suriname': 'SR',
    'sweden': 'SE',
    'switzerland': 'CH',
    'syria': 'SY',
    'tahiti': 'PF',
    'tajikistan': 'TJ',
    'tanzania': 'TZ',
    'thailand': 'TH',
    'togo': 'TG',
    'tonga': 'TO',
    'trinidad and tobago': 'TT',
    'tunisia': 'TN',
    'turkey': 'TR',
    'türkiye': 'TR',
    'turkiye': 'TR',
    'turkmenistan': 'TM',
    'turks and caicos islands': 'TC',
    'uganda': 'UG',
    'ukraine': 'UA',
    'united arab emirates': 'AE',
    'uae': 'AE',
    'united states': 'US',
    'usa': 'US',
    'uruguay': 'UY',
    'us virgin islands': 'VI',
    'uzbekistan': 'UZ',
    'vanuatu': 'VU',
    'venezuela': 'VE',
    'vietnam': 'VN',
    'wales': 'GB-WLS',
    'yemen': 'YE',
    'zambia': 'ZM',
    'zimbabwe': 'ZW',
};

export const getTeamCountryCode = (teamName) => {
    if (!teamName) return null;
    return TEAM_NAME_TO_COUNTRY_CODE[teamName.trim().toLowerCase()] || null;
};
